import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form'
import {Row, Form, Divider} from 'antd';
import {RTLCol,RTLButton} from '../RTLKit';

/* ------ Field -------- */
import TextField from '../formFields/TextField';

/* ------ Validate / Warn  -------- */
import ValidateForm from './parts/addValidate';
import WarnForm from './parts/addWarn';
import jwtDecode from "jwt-decode";
import Loading from "../loading/loading";

class AddEditForm extends Component {
    constructor(props) {
        super(props);

        //---- Detect Add or Edit module
        this.state = {
            mode: this.props.match.params.id ? 'edit' : 'add',
            itemId: this.props.match.params.id ? this.props.match.params.id : null, // item id in edit mode
            formLayout: 'horizontal'
        };

    }

    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    componentWillMount() {
        if (this.props.match.params.id){
            let id = this.props.match.params.id;
            this.props.getItem(id)
        }
    }

    render() {
        var _self = this;
        const {formLayout} = this.state;

        /*---- set mode ---*/
        if(this.props.initialValues) {
            this.props.initialValues.mode=this.state.mode
        }

        return (
            <Form layout={formLayout} mode={this.state.mode} onSubmit={this.onFormSubmit.bind(this)} >
                <Row>
                    <Divider orientation="left">{this.state.mode == 'edit' ? "ویرایش" : "ایجاد"} استان</Divider>
                </Row>
                {this.state.mode == 'edit' ?
                    <Loading list={this.props.initialValues} />
                : null}
                <Row type="flex" justify="start" align="middle">
                    <RTLCol md={18} sm={24} type="flex" justify="start" align="middle" >
                        <Row gutter={16}>
                            <Field
                                name="title"
                                component={TextField}
                                type="text"
                                label="عنوان"
                                placeholder="عنوان"
                            />
                            <Field
                                name="code"
                                component={TextField}
                                type="text"
                                label="کد"
                                placeholder="کد"
                            />
                        </Row>
                        <Row>
                            <RTLButton loading={this.props.common.isProgressing} type="primary"  shape="round" htmlType="submit" >
                                {this.state.mode == 'edit' ? "ویرایش" : "ایجاد"}
                            </RTLButton>
                            <RTLButton href="#/state/list" className="backBtn" type="default" shape="round">
                                بازگشت
                            </RTLButton>
                        </Row>
                    </RTLCol>
                </Row>
            </Form>

        );
    }

}

export default AddEditForm = reduxForm({
    form: 'addState',        // <--- a unique name for the form
    validate: ValidateForm, // <--- validation function given to redux-form
    warn: WarnForm
})(AddEditForm)
